<template>
  <div>
    <export-btn  v-bind='$attrs'  ref='refExportLink'
                 :can-export="userPermissions.indexOf('plc_export')>-1"
                 :lint-title='`导出`' :title='`下载刊例`'
                 @export='exportData(searchCondition)'
                 class-name='export-btn'
                 style='display: inline;font-size: 14px' />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ExportBtn from '@/components/export/ExportBtn'
import { getPlcExportData } from '@/api/plc'

export default {
  name: 'PlcExport',
  components: { ExportBtn },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  props: {
    searchCondition: {
      type: Object,
      default() {

      }
    }
  },
  methods: {
    //导出表格
    // eslint-disable-next-line no-unused-vars
    async exportData(searchCondition) {
      try {
        // eslint-disable-next-line no-unused-vars
        const date = new Date()
        //获取数据
        const data = await getPlcExportData(searchCondition.id)
        // // 生成excel
        const response = await this.$api.downloadPublicationExcelByData(data)
        const name = `【缇苏】${searchCondition.year}年${searchCondition.month}月刊例（含税）-${date.getMonth() + 1}.${date.getDate()}`
        this.$refs[`refExportLink`].exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    }
  }
}
</script>

<style scoped>

</style>
